import {
  execute as gqlExecute,
  parse,
  GraphQLError,
  GraphQLSchema,
} from "graphql";
import type { Variables } from "./types";
import { GraphQLClientResponse } from "../client/types";

export interface ExecuteQueryArgs<TVars extends Variables> {
  schema: GraphQLSchema;
  query: string;
  resolvers?: { [key: string | symbol]: unknown };
  context?: unknown;
  variables?: TVars;
}

const parseRejection = <TError>(
  errors: readonly TError[]
): { response: { errors: readonly TError[] } } => ({ response: { errors } });

export const execute = <TData, TVars extends Variables>({
  schema,
  query,
  resolvers = {},
  context,
  variables,
}: ExecuteQueryArgs<TVars>): Promise<GraphQLClientResponse<TData>> => {
  return Promise.resolve(
    gqlExecute({
      schema,
      document: parse(query),
      contextValue: context,
      rootValue: resolvers,
      variableValues: variables,
    })
  ).then(
    ({ data, errors }) => {
      if (errors) {
        return Promise.reject(parseRejection(errors));
      }

      return {
        status: 200,
        data: data as unknown as TData,
      };
    },
    (errors) => Promise.reject(parseRejection(errors as GraphQLError[]))
  );
};
